<dx-popup
    title="Margin Calculation Details"
    [width]="1000"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    @if (hasChanges()) {
        <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
        </dxi-popup-toolbar-item>
    }
    @if (hasChanges()) {
        <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
        </dxi-popup-toolbar-item>
    }

    <div class="flex-fill d-flex">
        <div class="d-flex flex-fill flex-column p-3">
            @if (job) {
                <dx-form [formData]="job">
                    <dxi-form-item>
                        <h2>{{ job.action.name }}</h2>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Revenue">
                        <dxi-form-item dataField="invoiceAmount" [disabled]="true"></dxi-form-item>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Time Expenses">
                        <dxi-form-item
                            dataField="hourExpense"
                            [disabled]="!isAdmin"
                            [editorOptions]="{ onValueChanged: recalculateValues }"
                        ></dxi-form-item>
                        <dxi-form-item dataField="totalMinutes" [disabled]="true"></dxi-form-item>
                        <dxi-form-item
                            dataField="timeExpenses"
                            [disabled]="true"
                            [label]="{ text: 'Time Expenses = Hour Expenses * Total Minutes / 60' }"
                        ></dxi-form-item>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Ton Expenses">
                        <dxi-form-item itemType="group">
                            <dxi-form-item
                                dataField="tonExpense"
                                [disabled]="!isAdmin"
                                [editorOptions]="{ onValueChanged: recalculateValues }"
                            ></dxi-form-item>
                            <dxi-form-item dataField="weight" [disabled]="true"></dxi-form-item>
                            <dxi-form-item
                                dataField="tonExpenses"
                                [disabled]="true"
                                [label]="{ text: 'Ton Expenses = Ton Expense * Weight' }"
                            ></dxi-form-item>
                        </dxi-form-item>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Profit">
                        <dxi-form-item dataField="profit" [disabled]="true" [label]="{ text: 'Revenue - (Time Expenses + Ton Expenses)' }">
                        </dxi-form-item>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Margin">
                        @if (relatedJob) {
                            <dxi-form-item dataField="totalProfits" [disabled]="true" [label]="{ text: 'Total Profits' }"> </dxi-form-item>
                        }
                        @if (relatedJob) {
                            <dxi-form-item dataField="totalRevenue" [disabled]="true" [label]="{ text: 'Total Revenue' }"> </dxi-form-item>
                        }
                        <dxi-form-item dataField="margin" [disabled]="true" [label]="{ text: 'Margin = Total Profits / Total Revenue' }">
                        </dxi-form-item>
                    </dxi-form-item>
                    <dxi-form-item>
                        <button class="btn btn-secondary" (click)="recalculateMargin()">Recalculate Margin</button>
                    </dxi-form-item>
                </dx-form>
            }
        </div>
        @if (relatedJob) {
            <div class="d-flex flex-fill flex-column p-3">
                <dx-form [formData]="relatedJob">
                    <dxi-form-item>
                        <h2>{{ relatedJob.action.name }}</h2>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Revenue">
                        <dxi-form-item dataField="invoiceAmount" [disabled]="true"></dxi-form-item>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Time Expenses">
                        <dxi-form-item
                            dataField="hourExpense"
                            [disabled]="!isAdmin"
                            [editorOptions]="{ onValueChanged: recalculateValues }"
                        ></dxi-form-item>
                        <dxi-form-item dataField="totalMinutes" [disabled]="true"></dxi-form-item>
                        <dxi-form-item
                            dataField="timeExpenses"
                            [disabled]="true"
                            [label]="{ text: 'Time Expenses = Hour Expenses * Total Minutes / 60' }"
                        ></dxi-form-item>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Ton Expenses">
                        <dxi-form-item itemType="group">
                            <dxi-form-item
                                dataField="tonExpense"
                                [disabled]="!isAdmin"
                                [editorOptions]="{ onValueChanged: recalculateValues }"
                            ></dxi-form-item>
                            <dxi-form-item dataField="weight" [disabled]="true"></dxi-form-item>
                            <dxi-form-item
                                dataField="tonExpenses"
                                [disabled]="true"
                                [label]="{ text: 'Ton Expenses = Ton Expense * Weight' }"
                            ></dxi-form-item>
                        </dxi-form-item>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Profit">
                        <dxi-form-item dataField="profit" [disabled]="true" [label]="{ text: 'Revenue - (Time Expenses + Ton Expenses)' }">
                        </dxi-form-item>
                    </dxi-form-item>
                </dx-form>
            </div>
        }
    </div>
</dx-popup>
